var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }